import { render, staticRenderFns } from "./SelectionModal.vue?vue&type=template&id=6aa5883f&scoped=true"
import script from "./SelectionModal.vue?vue&type=script&lang=js"
export * from "./SelectionModal.vue?vue&type=script&lang=js"
import style0 from "./SelectionModal.vue?vue&type=style&index=0&id=6aa5883f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa5883f",
  null
  
)

export default component.exports